import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SpeakersHeader from './components/SpeakersHeader';
import TheoreticalSessions from './components/TheoreticalSessions';
import PracticalSessions from './components/PracticalSessions';

const SpeakersPage = () => {
  return (
    <>
      <title>Konuşmacılar | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 konuşmacıları. Alanında uzman diş hekimleri ve akademisyenler ile teorik oturumlar ve uygulamalı kurslar. Genç Diş Hekimliği Derneği 2. Ulusal Kongresi." />
      <meta name="keywords" content="istanbul dental kongresi konuşmacılar, diş hekimliği uzmanları, dental kongre 2026 akademisyenler, implantoloji uzmanı istanbul" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/konusmacilar" />
      <meta property="og:title" content="Konuşmacılar | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="Alanında uzman diş hekimleri ve akademisyenler. 2. Ulusal İstanbul Dental Kongresi 2026." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/konusmacilar" />
      <div className="min-h-screen bg-white">
        <Navbar />
        <SpeakersHeader />
        <TheoreticalSessions />
        <PracticalSessions />
        <Footer />
      </div>
    </>
  );
};

export default SpeakersPage;
